module.exports = {
    adicionarPaciente: 'Adicionar paciente',
    alterarAtividadeInstituicao: 'Alterar atividade de ronda da instituição',
    alterarPaciente: 'Alterar paciente',
    ausenciaDriveRespiratorio: 'Ausência do drive respiratório',
    ausenciaEfeitoDrogasDepressoras: 'Ausência de efeito de drogas depressoras do sistema nervoso central e de bloqueadores neuromusculares, conforme tabela?',
    ausenciaReflexoCorneoPalpebral: 'Ausência do reflexo corneopalpebral',
    ausenciaReflexoOculoMotor: 'Ausência do reflexo oculo-motor',
    ausenciaTosse: 'Ausência da tosse',
    avisoVerificarSetor:
        'Atenção! Todos os setores vinculados a instituição de forma ativa deverão ser visitados de ronda em ronda. Caso um setor seja inserido ou desativado, a modificação de sua vinculação com a instituição terá efeito na ronda subsequente a modificação.',
    causaComa: 'Causas do coma',
    causaNaoNotificacaoCet: 'Causa para não notificação à CET',
    causaNeurologica: 'Causa neurológica',
    complementar: 'Complementar',
    confirmacaoExclusaoPaciente: 'Confirma a exclusão do paciente? Esta ação não poderá ser desfeita.',
    confirmarAlteracaoPaciente: 'Confirma a alteração do paciente?',
    confirmarCadastroPaciente: 'Confirma o cadastro do paciente em monitoramento?',
    confirmarCadastroSetorRonda: 'Confirma o cadastro do setor?',
    confirmarCadastroGrupoSetorRonda: 'Confirma o cadastro do grupo de setores?',
    confirmarAlteracaoSetorRonda: 'Confirma a alteração do setor?',
    confirmarAlteracaoGrupoSetorRonda: 'Confirma a alteração do grupo de setores?',

    confirmarCriacaoRonda: 'Confirmar a criação da ronda?',
    confirmarEncerramentoMonitoramento: 'Confirma o encerramento do monitoramento deste paciente?',
    confirmarEncerramentoPreenchimentoPaciente: 'Confirma o preenchimento deste paciente?',
    confirmarInformativoObito: 'Confirma o informativo de óbito deste paciente?',
    confirmarInsercaoPaciente: 'Confirma a inserção do paciente?',
    confirmarNovaRonda: 'Confirma a criação da nova ronda?',
    confirmarPeriodosPadrao: 'Confirma a criação de períodos padrão (08:00hrs, 10:00hrs, 14:00hrs)?',
    continuacaoMonitoramento: 'Continuação do monitoramento',
    criarNovosPeriodos: 'Criar novos períodos',
    cuidadosDoacao: 'Doação',
    cumpreTempoTratamentoObservacaoHospitalar: 'Cumpre o tempo mínimo de tratamento e observação hospitalar?',
    dadosClinicos: 'Dados clínicos',
    dadosCriacao: 'Dados de criação',
    dadosInformativoObito: 'Dados do informativo de óbito',
    dadosRonda: 'Dados da ronda',
    dataAteCriacao: 'Data final de criação',
    dataAteInicio: 'Data final',
    dataConclusao: 'Data de conclusão',
    dataCriacao: 'Data de criação',
    dataDeCriacao: 'Data inicial de criação',
    dataDeInicio: 'Data inicial',
    dataHoraDesligamentoSedacao: 'Data e hora do desligamento da sedação',
    dataInicio: 'Data de início',
    dataObito: 'Data do óbito',
    dataObitoFinal: 'Data final do óbito',
    dataObitoInicial: 'Data inicial do óbito',
    desativarPeriodosDeRonda: 'Desativar períodos de rondas da instituição',
    descricaoMaximo: 'A descrição deve ter no máximo 256 caracteres',
    pacientesMonitoramento: 'Pacientes em monitoramento',
    editarRondas: 'Editar Rondas',
    erroAlterarAtividade: 'Ocorreu um erro ao alterar a atividade da ronda',
    erroAoExcluirPaciente: 'Houve um erro ao excluir o paciente. Por favor, tente novamente.',
    erroAtivarRonda: 'Erro ao ativar ronda',
    erroCarregarDadosPaciente: 'Houve um erro ao carregar os dados do paciente. Por favor, tente novamente.',
    erroCarregarDadosRonda: 'Houve um erro ao carregar os dados da ronda. Por favor, tente novamente.',
    erroCriarInstituicaoRonda: 'Houve um erro ao cadastrar a instituição',
    erroCriarRonda: 'Houve um erro ao criar a ronda',
    erroCriarRonda: 'Houve um erro ao criar o paciente',
    erroCriarPeriodoRonda: 'Não foi possível criar o(s) período(s) de ronda.',
    erroEditarRonda: 'Houve um erro ao editar a ronda',
    erroEditarRonda: 'Houve um erro ao editar o paciente',
    erroEditarRondas: 'Ocorreu um erro ao editar as rondas',
    erroEditarRondaRecente: 'Não é possível editar esta ronda. Uma nova ronda foi criada.',
    erroInativarRonda: 'Erro ao inativar ronda',
    finalizarPreenchimentoRonda: 'Finalizar preenchimento da ronda?',
    funcionarioResponsavel: 'Funcionário responsável',
    glasgow: 'Glasgow',
    grupoSetor: 'Grupo de setores',
    historicoRonda: 'Histórico de rondas',
    horaDeInicio: 'Hora de inicio',
    identificadorPaciente: 'Identificador do paciente',
    informativoObito: 'Informativo de óbito',
    iniciaisPaciente: 'Iniciais do paciente',
    iniciarComplementoRonda: 'Você deseja preencher a ronda agora?',
    iniciarEditarRonda: 'Você deseja editar a ronda agora?',
    inicioRonda: 'Selecione o horário de início da ronda',
    instituicaoJaPresente: 'A instituição selecionada já está presente na listagem.',
    instituicaoRondaAdicionada: 'A nova instituição de ronda foi adicionada. Você gostaria de criar períodos de ronda ou utilizar os já padronizados no sistema?',
    label_situacao_paciente: {
        cancelado: 'Cancelado',
        concluida: 'Concluída',
        emPreenchimento: 'Em preenchimento',
        pendente: 'Pendente'
    },
    label_situacao_ronda: {
        cancelada: 'Cancelada',
        concluida: 'Finalizada',
        emPreenchimento: 'Em preenchimento',
        pendente: 'Pendente'
    },
    margem: 'Margem',
    margemDaRonda: 'Margem da ronda',
    margemMaxima: 'Máximo de 4 horas',
    margemMinima: 'Mínimo de 1 hora',
    mensagemCriarPeriodosRonda: 'Você deseja utilizar os períodos padrões de ronda (08:00hrs, 10:00hrs, 14:00hrs) ou criar novos?',
    morteEncefalica: 'Morte encefálica',
    motivoInternacao: 'Motivo da internação',
    motivoTerminoContinuacaoMonitoramento: 'Motivo do término da continuação do monitoramento',
    nenhumaInstituicaoLiberada: 'Nenhuma instituição liberada para o seu usuário. Contate a administração e tente novamente.',
    nenhumDadosParaExibir: 'Nenhum dado para exibição',
    nenhumRondaAdicionada: 'Nenhuma ronda adicionada.',
    nomeMaximo: 'O nome deve ter no máximo 20 caracteres',
    nomeMinimo: 'O nome deve ter no mínimo 3 caracteres',
    notificadaCentralTransplantes: 'A Central de Transplantes foi notificada?',
    novaInstituicao: 'Nova instituição',
    novaRonda: 'Nova ronda',
    numeroLeito: 'Leito',
    numeroRonda: 'Número da ronda',
    outraCausaComa: 'Outra causa do coma',
    outraCausaNaoNotificacaoCet: 'Outra causa para não notificação à CET',
    outraCausaNeurologica: 'Outra causa neurológica',
    outroMotivoInternacao: 'Outro motivo da internação',
    outroMotivoTerminoContinuacaoMonitoramento: 'Outro motivo do término da continuação do monitoramento',
    outrosPacientes: 'Outros pacientes',
    outroTipoSedacao: 'Outro tipo de sedação',
    pacienteApresentaCriteriosInvestigacaoMe:
        'Na presença dos sinais acima configura-se o conceito de morte encefálica iminente que indica o procedimento de retirada de sedação - acionar o coordenador médico da CHT para que articule a suspensão da sedação com o médico plantonista.',
    pacienteContinuaMonitoramento: 'O paciente continua em monitoramento?',
    pacienteCriadoSucesso: 'Paciente criado com sucesso',
    pacienteEditadoSucesso: 'Paciente editado com sucesso',
    pacienteExcluidoComSucesso: 'O paciente foi excluído com sucesso.',
    pacienteNaoApresentaCriteriosInvestigacaoMe: 'O paciente não apresenta critérios para iniciar a investigação da ME',
    pacientePendenteTooltip: 'Esse paciente está pendente e necessita ter seu preenchimento realizado.',
    pacienteEmMonitoramentoTooltip: 'Paciente em monitoramento',
    pacienteConcluidoCriterioMeTooltip: 'Concluído COM critérios de ME',
    pacienteConcluidoSemCriterioMeTooltip: 'Concluído SEM critérios de ME',
    pacientesEmMonitoramentoEscalaGlasgow: 'Pacientes em monitoramento (escala Glasgow)',
    pacientesEmMonitoramentoPorSetor: 'Pacientes em monitoramento por setor',
    pacientesFaltantes: 'Ao menos um paciente precisa ter o preenchimento concluído para finalizar a ronda.',
    pacientesPendentesPreenchimento: 'Existem pacientes que ainda não tiveram o preenchimento concluído.',
    periodosRonda: 'Períodos de ronda',
    possuiPacienteEmMonitoramento: 'Há pacientes com lesão cerebral catastrófica e/ou com escala de coma de Glasgow < 8 para monitorar?',
    presencaLesaoEncefalicaCausaConhecida: 'Presença de lesão encefálica de causa conhecida, irreversível e capaz de causar a morte encefálica?',
    pressaoArterialSistolicaArterialMedia: 'Pressão arterial sistólica >= 100 mmHg ou pressão arterial média >= 65 mmHg?',
    producaoHospital: 'Produção por hospital',
    proximaRondaAviso: 'A próxima ronda será gerada automaticamente em',
    proximaRondaPrazoAviso: (dataProximaRonda, horasProximaRonda) => `A ronda atual pode ser editada até o início da próxima ronda que será criada em ${dataProximaRonda} às ${horasProximaRonda}.`,
    realizadaPrimeiraAvaliacaoMorteEncefalica: 'Já foi realizada a primeira avaliação de morte encefálica?',
    registroHospital: 'Registro no hospital',
    ronda: 'Ronda',
    rondaCriadaSucesso: 'Ronda criada com sucesso',
    rondaEditadaSucesso: 'Ronda editada com sucesso',
    rondaEmPreenchimentoAviso: (data, horas) => `Existe uma ronda em preenchimento que deve ser finalizada até a próxima ronda dia ${data} às ${horas}.`,
    rondaPendenteAviso: (data, horas) => `Existe uma ronda pendente que pode ser complementada até a próxima ronda dia ${data} às ${horas}.`,
    rondaPendenteTooltip: 'Essa ronda está pendente e necessita ser concluída.',
    rondaRepetida: 'Já existe uma ronda cadastrada para este horário',
    rondaFinalizada: 'Esta ronda já foi finalizada e não pode ser editada.',
    rondas: 'Rondas',
    rondasAlteradasSucesso: 'Rondas alteradas com sucesso!',
    rondaSobreposta: 'Já existe uma ronda cadastrada para esse intervalo de horário',
    salvarAlteracoes: 'Salvar Alterações',
    saturacaoOxigenioMaior94: 'Saturação de oxigênio > 94%?',
    sedacao: 'Sedação',
    selecionarGrupoSetor: 'Selecione o grupo de setores',
    selecionarInstituicao: 'Selecionar instituição',
    selecionarInstituicaoVinculo: 'Selecione a instituição de vínculo',
    selecionarSetor: 'Selecione o setor',
    setoresNecessidadeRonda: 'Setores para realização de ronda',
    suasRondas: 'Suas rondas',
    sucessoAtivarRonda: 'Ronda ativada com sucesso',
    sucessoCriarInstituicaoRonda: 'Instituição cadastrada com sucesso',
    sucessoCriarPeriodoRonda: 'Período(s) de ronda criado(s) com sucesso.',
    sucessoInativarRonda: 'Ronda inativada com sucesso',
    tresMaisAusencias: '3 + ausências',
    temperaturaCorporalMaior35: 'Temperatura corporal maior que 35ºC?',
    tempoInternacaoUnidadeCriticaDias: 'Tempo de internação na U.C. (dias)',
    tempoInternacaoUnidadeCriticaHoras: 'Tempo de internação na U.C. (horas)',
    tempoRestanteProximaRonda: 'Tempo restante para a próxima ronda',
    tempoTratamento: 'Tempo de tratamento',
    tipoSedacao: 'Tipo de sedação',
    tiposSedacao: 'Tipos de sedação',
    tiposSedacaoAdicionados: 'Tipos de sedação adicionados',
    totalPacientes: 'Total de pacientes',
    totalRondas: 'Total de rondas',
    usarPeriodosPadrao: 'Usar períodos padrão',
    vincularSetorInstituicao: 'Vincular setor e instituição',
    vinculoSetores: 'Vínculo de setores',
    visualizacaoPaciente: 'Visualização do paciente',
    visualizacaoRonda: 'Visualização da ronda',
    pacientesComGlasgow3: 'Pacientes com glasgow 3',
    pacientesComGlasgow3SemSedacao: 'Pacientes com glasgow 3 sem sedação',
    pacientesHospital: 'Pacientes por hospital',
    dataInicioBuscaAtiva: 'Data de início da busca ativa'
};
